import { render, staticRenderFns } from "./WebBundy.vue?vue&type=template&id=9e5928ae"
import script from "./WebBundy.vue?vue&type=script&lang=js"
export * from "./WebBundy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports